/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Microsoft Ads Event Listeners
 *
 * Uses the unified event system (pmw:*) with firing decisions.
 * Checks payload.firing.bing.fire_browser before firing the browser pixel.
 *
 * @see https://help.ads.microsoft.com/#apex/ads/en/56684/2
 * @see https://help.ads.microsoft.com/#apex/ads/en/60118/-1
 *
 * Supported events: add_payment_info, add_to_cart, add_to_wishlist, begin_checkout, 
 * checkout_progress, exception, generate_lead, login, page_view, purchase, refund, 
 * remove_from_cart, screen_view, search, select_content, set_checkout_option, share, 
 * sign_up, timing_complete, view_item, view_item_list, view_promotion, view_search_results
 */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.bing?.uet_tag_id && !pmwDataLayer?.pixels?.bing?.loaded) {
		if (pmw.canLoadBingPixel()) pmw.load_bing_pixel();
	}
});

// https://help.ads.microsoft.com/#apex/ads/en/60118/-1
// add-to-cart event
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: add_to_cart event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// https://help.ads.microsoft.com/#apex/ads/en/60118/-1
// view product event
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: view_item event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// https://help.ads.microsoft.com/#apex/ads/en/60118/-1
// view category event
pmw.bus.on("pmw:pixel:view-category", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: view_category event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// https://help.ads.microsoft.com/#apex/ads/en/60118/-1
// view search event
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: view_search_results event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

/**
 * The ecomm_pagetype parameter identifies the type of page the user has visited.
 * Valid options: home, searchresults, category, product, cart, purchase, other.
 */
pmw.bus.on("pmw:pixel:everywhere-else", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: generic event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// https://help.ads.microsoft.com/#apex/ads/en/60118/-1
// view order received page event
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (pmw.canNotFireUetq()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "bing")) return;

		const bingData = payload.pixels?.bing;
		if (!bingData) return;

		window.uetq.push("event", bingData.event_name, bingData.event_data);
		pmw.console.log("Microsoft Ads: purchase event sent", bingData.event_data);

	} catch (e) {
		console.error(e);
	}
});

document.addEventListener("pmw:consent:update", ({detail}) => {

	const consent = detail;

	try {
		if (!pmwDataLayer?.pixels?.bing?.loaded) return;

		let consentSettings = {
			ad_storage: consent.marketing ? "granted" : "denied",
		};

		// If the marketing category is not allowed, set the _uetmsdns session cookie
		// to prevent the Microsoft Ads pixel from sending events
		if (!pmw.consent.categories.get().marketing) {
			pmw.setCookie("_uetmsdns");
		} else {
			pmw.deleteCookie("_uetmsdns");
		}

		window.uetq.push("consent", "update", consentSettings);
		pmw.console.log("Microsoft Ads Consent Mode updated", consentSettings);

	} catch (error) {
		console.error(error);
	}
}, true);
